import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useProps } from '@coveord/plasma-mantine';
import { TimePicker } from '@mantine/dates';
import { useCallback, useState } from 'react';
import { TimePickerUtils } from './TimePickerInputUtils.js';
var defaultProps = {
    value: {
        hour: 10,
        minute: 0
    },
    withSeconds: false
};
export var TimePickerInput = function TimePickerInput(_props) {
    var props = useProps('TimePickerInput', defaultProps, _props);
    var formatValue = TimePickerUtils.formatHourMinuteToString(props.value);
    var _useState = _sliced_to_array(useState(formatValue), 2), value = _useState[0], setValue = _useState[1];
    var handleChange = useCallback(function(newValue) {
        var _props_onChange;
        setValue(newValue);
        props === null || props === void 0 ? void 0 : (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, TimePickerUtils.formatStringToHourMinute(newValue));
    }, [
        props
    ]);
    return /*#__PURE__*/ _jsx(TimePicker, _object_spread_props(_object_spread({}, props), {
        value: value,
        onChange: handleChange
    }));
};

//# sourceMappingURL=TimePickerInput.js.map